import {useMemo} from 'react';

import {useAppSelector} from 'src/redux/hooks';
import {getUrlWithEncodingAndAuth} from 'src/shared/utils/urlHelpers';

/**
 * Returns the authenticated instance logo URL, or `null` if no custom logo is configured.
 * Encapsulates Redux selectors, JSON parsing, and URL resolution.
 */
export const useInstanceLogoUrl = (): string | null => {
  const {instance} = useAppSelector(state => state.session);
  const {accessToken} = useAppSelector(state => state.auth);

  const rawUrl = instance?.logoUrl;

  return useMemo(() => {
    if (!rawUrl || rawUrl === '' || !accessToken) {
      return null;
    }

    try {
      const logoDetails = JSON.parse(rawUrl);
      if (logoDetails && logoDetails[0]?.value) {
        return getUrlWithEncodingAndAuth(logoDetails[0].value, accessToken);
      }
    } catch {
      // Invalid JSON — skip logo
    }

    return null;
  }, [rawUrl, accessToken]);
};
